export * from './appVersionVO';
export * from './clientLogVO';
export * from './dateiVO';
export * from './errorResponseDTO';
export * from './faqEntryVO';
export * from './httpErrorResponseVO';
export * from './kontaktVO';
export * from './kursInfoPageVO';
export * from './kursInfoTeilnehmerVO';
export * from './kursInfoVO';
export * from './kursanmeldungVO';
export * from './loginResponseVO';
export * from './loginVO';
export * from './pageInfoVO';
export * from './pageVO';
export * from './passwortAenderungVO';
export * from './passwortResetVO';
export * from './registrierungVO';
export * from './teilnehmerVO';
export * from './userInfoVO';
